export default {
    name: 'sps-auth',
    async handle(state, to, from, next) {
        if (to.path.includes('error') || to.path.hash === '#out-of-service')
            return false;

        await state.player.ensure();

        if (state.player.isLoggedIn())
            return false;

        if (to.name === 'home' || to.name === 'login' )
            next();
        else
            next('/');
        
        return true;
    }
}



// WEBPACK FOOTER //
// ./skins/xkiosk/routehandlers/common/auth.routehandler.js